import { enableProdMode, importProvidersFrom } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/routing/app-routing.module';
import { TranslocoRootModule } from './app/transloco-root.module';
import { environment } from './environments/environment';

import { CoreModule } from './app/core/core.module';

import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { TitleStrategy } from '@angular/router';
import {
	AZURE_MAPS_API_CONFIG,
	PopUpService,
	TOAST_CONTAINER_CONFIG,
	ToastContainerConfig,
	ToastService,
} from 'vis-ods-angular';
import { CustomPageTitleStrategy } from './app/core/title.strategy';
import { LoadingAnimationService } from './app/modules/loading-animation/loading-animation.service';

if (environment.production) {
	enableProdMode();
}

bootstrapApplication(AppComponent, {
	providers: [
		{
			provide: TOAST_CONTAINER_CONFIG,
			useValue: {
				stackToasts: true,
				desktopOrientation: { vertical: 'bottom', horizontal: 'right' },
				mobileOrientation: { vertical: 'top', horizontal: 'center' },
				toastClickThrough: environment.toastClickThrough,
			} as ToastContainerConfig,
		},
		LoadingAnimationService,
		PopUpService,
		ToastService,
		importProvidersFrom(
			BrowserModule,
			CoreModule.forRoot(),
			AppRoutingModule,
			TranslocoRootModule,
			FormsModule,
			ReactiveFormsModule,
		),
		// provider for azure autosuggest
		{
			provide: AZURE_MAPS_API_CONFIG,
			useValue: {
				apiUrl: environment.apiBaseUrl,
			},
		},
		{ provide: TitleStrategy, useClass: CustomPageTitleStrategy },
		provideAnimations(),
		provideHttpClient(withInterceptorsFromDi()),
	],
}).catch((err) => console.error(err));
